// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cursor-hand {
  cursor: pointer;
}

.font-bold {
  font-weight: bold;
}

.question {
  font-size: large;
  width: 40%;
  display: block;
}

.error {
  color: #c3002f;
}

.checkbox {
  list-style-type: none;
}

.check-option {
  text-align: center;
  font-size: large;
  display: block ruby;
}

.rating-check-option {
  text-align: center;
  font-size: large;
}

.rating-question {
  font-size: large;
  width: 100%;
  display: block;
}
.rating-row {
  display: block ruby;
  width: 100%;
}

.comments {
  margin-left: 0px;
    margin-top: 20px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/survey/ng-formly/Components/common.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;IACd,gBAAgB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[".cursor-hand {\r\n  cursor: pointer;\r\n}\r\n\r\n.font-bold {\r\n  font-weight: bold;\r\n}\r\n\r\n.question {\r\n  font-size: large;\r\n  width: 40%;\r\n  display: block;\r\n}\r\n\r\n.error {\r\n  color: #c3002f;\r\n}\r\n\r\n.checkbox {\r\n  list-style-type: none;\r\n}\r\n\r\n.check-option {\r\n  text-align: center;\r\n  font-size: large;\r\n  display: block ruby;\r\n}\r\n\r\n.rating-check-option {\r\n  text-align: center;\r\n  font-size: large;\r\n}\r\n\r\n.rating-question {\r\n  font-size: large;\r\n  width: 100%;\r\n  display: block;\r\n}\r\n.rating-row {\r\n  display: block ruby;\r\n  width: 100%;\r\n}\r\n\r\n.comments {\r\n  margin-left: 0px;\r\n    margin-top: 20px;\r\n}\r\n\r\n.sr-only {\r\n  position: absolute;\r\n  width: 1px;\r\n  height: 1px;\r\n  padding: 0;\r\n  margin: -1px;\r\n  overflow: hidden;\r\n  clip: rect(0, 0, 0, 0);\r\n  white-space: nowrap;\r\n  border: 0;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
